import Vue from 'vue'
import Router from 'vue-router'
import Gallery from './pages/Gallery'
import PianoDetails from './pages/PianoDetails'
import Favorites from './pages/Favorites'
import $ from 'jquery'

Vue.use(Router)

export default new Router({
    scrollBehavior(to) {
        const offset = $('[data-gallery-app]').offset()

        if (to.name !== 'Gallery') {
            return {x: 0, y: offset && offset.top || 0}
        }
    },
    routes: [
        {
            path: '/',
            name: 'Gallery',
            component: Gallery,
        },
        {
            path: '/pianos/:id',
            name: 'Pianos Detail',
            component: PianoDetails,
        },
        {
            path: '/favorites',
            name: 'Favorites',
            component: Favorites,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/router.js